// extracted by mini-css-extract-plugin
export default {"form":"TemplateForm_form__ar5lE","gridItem":"TemplateForm_gridItem__WPBC1"};